import type { DecisionRow } from "@/api/client.js";
import { Button } from "@/components/ui/button.js";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog.js";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  row: DecisionRow | null;
  onConfirm: () => void;
  isPending?: boolean;
};

export function UnbanConfirmDialog({ open, onOpenChange, row, onConfirm, isPending }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Unban decision?</DialogTitle>
          <DialogDescription>
            This removes ban decision <strong>{row?.id}</strong>
            {row?.value ? (
              <>
                {" "}
                for <strong>{row.value}</strong>
              </>
            ) : null}
            . This cannot be undone from the console alone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={isPending}>
            {isPending ? "Removing…" : "Confirm unban"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
